import { useState, useEffect } from 'react';
import { usersGraphqlService, UserRole } from '@/services/api/users/usersGraphqlService';
import { useAuth } from '@/contexts/AuthContext';

export const useReferenceUserRoles = () => {
  const [userRoles, setUserRoles] = useState<UserRole[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { hasuraToken } = useAuth();

  useEffect(() => {
    const fetchUserRoles = async () => {
      if (!hasuraToken) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await usersGraphqlService.getReferenceUserRoles(hasuraToken);
        
        if (response.success && response.data) {
          setUserRoles(response.data.reference_user_role || []);
          setError(null);
        } else {
          setError('Failed to fetch user roles');
        }
      } catch (err) {
        console.error('Error fetching user roles:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch user roles');
      } finally {
        setLoading(false);
      }
    };

    fetchUserRoles();
  }, [hasuraToken]);

  return { userRoles, loading, error };
};
